import React, { useState, useMemo, useContext } from "react";
import { DataTableContext } from "../Tabs/Overview";
import { ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { ViewMasterCampaignsContext } from "../index";
import { copyCampaign, fetchCampaignsByPlatformId } from "../../../Flux/Actions/MasterCampaignActions";
import CloneCampaignModal from "../../Modals/CloneCampaignModal";
import Modal from "@acadia-ui/modal";
import Loading from "@acadia-ui/loading";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { multipleMasterCampaignsSelected } from "./actionValidations";

export default () => {
	const [isLoading, setIsLoading] = useState(false);
	// Import various contexts
	const { checkboxSelections, dataProvider, dataTableApi } = useContext(DataTableContext);
	const { addBanner } = useContext(ViewMasterCampaignsContext);

	// Property used to disable the Trigger button given specific criteria
	const disabled = useMemo(() => multipleMasterCampaignsSelected(checkboxSelections) || checkboxSelections?.selectedActivationCampaigns?.length != 1, [checkboxSelections]);

	// Extract the actual selected campaign data from the overall data set
	const selectedCampaignData = useMemo(() => {
		if (dataProvider?.data && !disabled) {
			const campaignInfo = checkboxSelections?.selectedActivationCampaigns?.[0];
			const { activationCampaignId, masterCampaignId, platform } = campaignInfo;
			const masterCampaign = dataProvider?.data?.find(({ MasterCampaignID }) => MasterCampaignID == masterCampaignId);
			const activationCampaign = masterCampaign?.ActivationCampaigns?.[platform]?.find(({ CampaignID }) => CampaignID == activationCampaignId);
			return activationCampaign || null;
		}
		return null;
	}, [checkboxSelections, disabled, dataProvider]);

	function handleClone(targetMasterCampaign) {
		setIsLoading(true);
		copyCampaign(selectedCampaignData, targetMasterCampaign?.value, [])
			.then((resp) => {
				addBanner(<ToastNotification type={TOAST_TYPE.SUCCESS} message="Data has successfully been cloned" timed={5000} />);
				dataTableApi?.current?.rowSelectionManager?.tree?.selectNode?.(false);
				setTimeout(() => {
					dataProvider?.update?.();
				}, 1);
			})
			.catch((error) => {
				console.log(error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}

	const [masterCampaigns, setMasterCampaigns] = useState([]);

	// Return a memoized object containing both of these components
	return useMemo(
		() => ({
			Trigger: () => (
				<Tooltip title="Clone" position={TOOLTIP_POSITION.BOTTOM_START}>
					<Button
						display={BUTTON_DISPLAY.ICON_BORDERED}
						size={BUTTON_SIZE.SMALL}
						icon={"icon-copy"}
						onClick={async () => {
							setIsLoading(true);
							setMasterCampaigns(await fetchCampaignsByPlatformId(selectedCampaignData));
							setIsLoading(false);
							setTimeout(() => Modal.show("cloneCampaignModal"), 1);
						}}
						disabled={disabled || selectedCampaignData?.IsDraft === "True"}
						id="cloneCampaignButton"
						data-tracking-id-alt="clone-campaign-button"
					>
						Clone
					</Button>
				</Tooltip>
			),
			DisplayedComponent: () => {
				if (selectedCampaignData) {
					return (
						<>
							{isLoading ? (
								<Loading />
							) : (
								<CloneCampaignModal
									// this comment exists to prevent eslint from making this unreadable.
									handleClone={handleClone}
									selectedCampaignData={selectedCampaignData}
									masterCampaigns={masterCampaigns}
								/>
							)}
						</>
					);
				}
				return <></>;
			}
		}),
		[selectedCampaignData, disabled, masterCampaigns, isLoading]
	);
};
